module.exports = __webpack_public_path__ + "static/media/bear-en.241d73b2.png";